import { makeV2APIURL } from '^/store/duck/API';
import { METHODS, useReactQueryMutation } from '^/utilities/api';
import { queryKey } from './useGetProjectDetail';

export const usePatchProject = ({ projectId = '' }: { projectId?: string }) => {
  const URL = makeV2APIURL('projects', projectId);
  return useReactQueryMutation({
    endpoint: URL,
    method: METHODS.PATCH,
    queryKey: [`${queryKey}-${projectId}`],
  });
};
